import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication/services/authenticationService.service';
import { SwUpdateService } from './services/sw-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private swUpdateService: SwUpdateService
  ) {
    if (this.authenticationService.checkLoginState()) {
      // this.router.navigate(['dashboard/lopend']);
    }
  }

  ngOnInit(): void {
    // Initialize service worker update checking
    this.swUpdateService.checkForUpdates();
  }
}
